import { Instagram, Youtube, Mail, Phone, MapPin, Lock } from "lucide-react";
import { LOGO } from "./assets";

export default function Footer() {
  const scrollTo = (href) =>
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });

  return (
    <footer data-testid="site-footer" className="bg-black border-t border-white/10 pt-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid md:grid-cols-3 gap-12 pb-16">
          <div>
            <img src={LOGO} alt="JJ Speed Factory" className="h-16 w-auto object-contain -ml-1" />
            <p className="text-white/50 mt-4 max-w-xs">
              Building faster, more explosive, more athletic humans across
              Northeast Ohio.
            </p>
          </div>

          <div>
            <p className="font-mono-accent text-xs tracking-[0.25em] uppercase text-white/40 mb-5">Explore</p>
            <ul className="space-y-3">
              {[["Results", "#results"], ["Services", "#services"], ["Train Anywhere", "#train-anywhere"], ["Training Options", "#training-options"], ["Required Forms", "#forms"], ["Contact", "#contact"], ["Book Free Evaluation", "#assessment"]].map(([label, href]) => (
                <li key={href}>
                  <button
                    data-testid={`footer-link-${href.replace("#", "")}`}
                    onClick={() => scrollTo(href)}
                    className="text-white/60 hover:text-white transition-colors duration-300"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono-accent text-xs tracking-[0.25em] uppercase text-white/40 mb-5">Connect</p>
            <ul className="space-y-3 text-white/60">
              <li className="flex items-center gap-3"><MapPin size={16} className="text-white/60" /> Mobile · Northeast Ohio</li>
              <li><a href="mailto:coachjohnsonrecruiting9@gmail.com" data-testid="footer-email" className="flex items-center gap-3 hover:text-white transition-colors break-all"><Mail size={16} className="text-white/60 shrink-0" /> coachjohnsonrecruiting9@gmail.com</a></li>
              <li><a href="tel:3043129317" className="flex items-center gap-3 hover:text-white transition-colors"><Phone size={16} className="text-white/60" /> 304-312-9317</a></li>
            </ul>
            <div className="flex gap-4 mt-6">
              <a href="https://instagram.com/jjspeedfactory" target="_blank" rel="noopener noreferrer" data-testid="footer-instagram" className="text-white/60 hover:text-white transition-colors duration-300"><Instagram size={22} /></a>
              <a href="#" data-testid="footer-youtube" className="text-white/60 hover:text-white transition-colors duration-300"><Youtube size={22} /></a>
            </div>
            <a
              href="/login"
              data-testid="footer-login-link"
              className="inline-flex items-center gap-2 mt-8 font-mono-accent text-xs tracking-[0.2em] uppercase text-white/60 hover:text-white transition-colors duration-300"
            >
              <Lock size={14} /> Portal Login
            </a>
          </div>
        </div>
      </div>

      <div className="leading-none select-none">
        <p className="font-display font-black uppercase text-[16vw] tracking-tighter text-white/[0.04] text-center whitespace-nowrap">
          SPEED FACTORY
        </p>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-6 flex flex-col sm:flex-row justify-between gap-2 text-white/40 text-xs">
          <span>© {new Date().getFullYear()} JJ Speed Factory. All rights reserved.</span>
          <span className="font-mono-accent tracking-wider">ORIGIN™ SYSTEM</span>
        </div>
      </div>
    </footer>
  );
}
